import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import Delivery from '../images/freeDeliveryWeb.webp'
import Figure from 'react-bootstrap/Figure'
import FigureCaption from 'react-bootstrap/FigureCaption'
import facebook from "../images/facebook.png"
import Instagram from "../images/instagram.png"
import Nextdoor from "../images/nextdoor.png"
import TikTok from "../images/tiktok.png"
import YouTube from "../images/youtube.png"
import './footer.css'



export default function Footer(){
    return(
        <div id="footer">
            <div id="contact">
                <h6 className="contact-subsections">Contact Us</h6>
                
                    <p className="contact-info"><a href="tel: 520-486-1753">Call</a></p>
            
                    <p className="contact-info"><a href="mailto: support@holisticgreenthings.com">Email</a></p>
            </div>
            <div id='connect'>
                <h6 className="contact-subsections">
                    Connect With Us!
                </h6>
                <a href="https://facebook.com/HolisticGreenThings" target="_blank" rel="noreferrer noopener" className='socialMedia'><Image className="socialMedia" src={facebook} width={20}/></a>
                <a href="https://www.instagram.com/holisticgreenthings/" target="_blank" rel="noreferrer noopener" className='socialMedia'><Image className="socialMedia" src={Instagram} width={20}/></a>
                <a href="https://nextdoor.com/pages/holistic-green-things-tucson-az" target="_blank" rel="noreferrer noopener" className='socialMedia'><Image className="socialMedia" src={Nextdoor} width={40}/></a>
                <a href="https://www.tiktok.com/@holistic.green.th?is_from_webapp=1&sender_device=pc" target="_blank" rel="noreferrer noopener" className='socialMedia'><Image className="socialMedia" src={TikTok} width={20}></Image></a>
                <a href="https://www.youtube.com/@HolisticGreenThings" target="_blank" rel="norferrer noopener" className='socialMedia'><Image className="socialMedia" src={YouTube} width={20}></Image></a>

            </div>
            <div id="find-us">
                <h6 className="contact-subsections">How to get our products</h6>
                <p className="find">Rustic Roots Farmers Market</p>
                <span className="find-span">Fridays - 8535 E. Speedway</span>
                <p className="find">Rustic Roots Farmers Market</p>
                <span className="find-span">Saturdays - 9848 E. Old Vail Rd.</span>
                <p className="find">Home Delivery</p>
                <span className="find-span">Tucson Metro, Vail, Rita Ranch </span>
            </div>
            
                

        </div>
            
                
                
            
         
        
    
         
        
    )
}